module.exports = __webpack_public_path__ + "img/qwen-format-fashion.51510de4.webp";